"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSearchModel = instanceOfSearchModel;
exports.SearchModelFromJSON = SearchModelFromJSON;
exports.SearchModelFromJSONTyped = SearchModelFromJSONTyped;
exports.SearchModelToJSON = SearchModelToJSON;
exports.SearchModelToJSONTyped = SearchModelToJSONTyped;
/**
 * Check if a given object implements the SearchModel interface.
 */
function instanceOfSearchModel(value) {
    if (!('sysName' in value) || value['sysName'] === undefined)
        return false;
    if (!('commandTimeS' in value) || value['commandTimeS'] === undefined)
        return false;
    if (!('commandTimeE' in value) || value['commandTimeE'] === undefined)
        return false;
    return true;
}
function SearchModelFromJSON(json) {
    return SearchModelFromJSONTyped(json, false);
}
function SearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sysName': json['sysName'],
        'apname': json['apname'] == null ? undefined : json['apname'],
        'sqlmode': json['sqlmode'] == null ? undefined : json['sqlmode'],
        'clientId': json['clientId'] == null ? undefined : json['clientId'],
        'clientName': json['clientName'] == null ? undefined : json['clientName'],
        'commandTimeS': (new Date(json['commandTimeS'])),
        'commandTimeE': (new Date(json['commandTimeE'])),
    };
}
function SearchModelToJSON(json) {
    return SearchModelToJSONTyped(json, false);
}
function SearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'sysName': value['sysName'],
        'apname': value['apname'],
        'sqlmode': value['sqlmode'],
        'clientId': value['clientId'],
        'clientName': value['clientName'],
        'commandTimeS': ((value['commandTimeS']).toISOString()),
        'commandTimeE': ((value['commandTimeE']).toISOString()),
    };
}
